export default "__VITE_ASSET__3dbf9f45__"